export default __webpack_public_path__ + "static/media/continuing-1.edc45ae1.jpg";